<template>
  <div class="user-wrapper">
    <div class="content-box">
      <a-dropdown>
        <span class="action ant-dropdown-link user-dropdown-menu">
          <a-avatar class="avatar" size="small" :src="avatar"/>
          <span>{{ nickname }}</span>
        </span>
        <a-menu slot="overlay" class="user-dropdown-menu-wrapper">
          <a-menu-item key="0">
            <a href="javascript:;" @click="handleToCenter">
              <a-icon type="user"/>
              <span>个人中心</span>
            </a>
          </a-menu-item>
          <!-- <a-menu-item key="1">
            <router-link :to="{ name: 'settings' }">
              <a-icon type="setting"/>
              <span>账户设置</span>
            </router-link>
          </a-menu-item> -->
          <a-menu-divider/>
          <a-menu-item key="3">
            <a href="javascript:;" @click="handleLogout">
              <a-icon type="logout"/>
              <span>退出登录</span>
            </a>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserMenu',
  components: {

  },
  data(){
    return {
        avatar:require('@/assets/icons/avatar-default.png'),
        nickname:''
    };
  },
  computed: {

  },
  mounted(){
    this.nickname = this.appUtils.getUserName();
  },
  methods: {
    handleToCenter () {
      window.location.href = this.appUtils.getDomainUrl();
    },
    handleLogout () {
      this.$confirm({
        title: '提示',
        content: '真的要注销登录吗 ?',
        onOk: () => {
            this.appUtils.removeLocalStorage(this.constStatic.TOKEN_KEY);
            this.appUtils.removeLocalStorage(this.constStatic.USER_INFO);
            this.appUtils.removeLocalStorage(this.constStatic.JTI);
            if(this.appUtils.getDomainProtal()){
              window.location.href = this.appUtils.getDomainProtal();
            }else{
              window.location.href = this.appUtils.getDomainUrl()+'/login';
            }
        },
        onCancel () {
        }
      })
    }
  }
}
</script>
